import api from './clients';

export const confirmacionesApi = {
  // Obtener entregas completadas
  getEntregas: async (params?: { fechaInicio?: string; fechaFin?: string; cliente?: string; incluirOcultos?: boolean }) => {
    const response = await api.get('/confirmaciones/entregas', { params });
    return response.data?.data || [];
  },

  // Obtener entrega por ID
  getEntrega: async (id: number) => {
    const response = await api.get(`/confirmaciones/entregas/${id}`);
    return response.data?.data;
  },

  // Enviar email de confirmación
  enviarEmail: async (id: number, data: { asunto: string; mensaje: string; adjuntarFactura: boolean }) => {
    const response = await api.post(`/confirmaciones/entregas/${id}/email`, data);
    return response.data?.data;
  },

  // Guardar factura
  guardarFactura: async (id: number, facturaUrl: string) => {
    const response = await api.put(`/confirmaciones/entregas/${id}/factura`, { facturaUrl });
    return response.data?.data;
  },

  // Ocultar tarjeta
  ocultar: async (id: number) => {
    const response = await api.put(`/confirmaciones/entregas/${id}/ocultar`);
    return response.data?.data;
  },

  // Estadísticas
  getEstadisticas: async () => {
    const response = await api.get('/confirmaciones/estadisticas');
    return response.data?.data;
  },
};